const config = {   EMPRESA: "zapresponder",GOOGLE_ANALYTICS_ZAPRESPONDER: 'G-DK715REW5F',   GOOGLE_ANALYTICS_MULTDESK: 'G-M7F16B1YBY',   GOOGLE_ANALYTICS_HML: 'G-H304X1XJ7C' }; export default config;
